import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  academicYear: null,
  status: 'idle',
  error: null,
};

const academicYearSlice = createSlice({
  name: 'academicYear',
  initialState,
  reducers: {
    setAcademicYear(state, action) {
      state.academicYear = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    clearAcademicYear(state) {
      state.academicYear = null;
      state.status = 'idle';
      state.error = null;
    },
    setError(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
  },
});

export const { setAcademicYear, clearAcademicYear, setError } = academicYearSlice.actions;

export default academicYearSlice.reducer;